"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runWithConcurrency = runWithConcurrency;
async function runWithConcurrency(items, concurrency, fn) {
    const results = new Array(items.length);
    let index = 0;
    async function worker() {
        while (index < items.length) {
            const current = index++;
            results[current] = await fn(items[current]);
        }
    }
    const workers = Array.from({ length: Math.min(concurrency, items.length) }, () => worker());
    await Promise.all(workers);
    return results;
}
//# sourceMappingURL=concurrency.js.map